// extracted by mini-css-extract-plugin
export default {"forgotPasswordPage":"style_forgotPasswordPage__VN-f7","emailBox":"style_emailBox__NU-um","emailHeader":"style_emailHeader__ptjR6"};